import { createAsyncThunk } from '@reduxjs/toolkit'

// Evita que dos dispatches idénticos (mismo thunk + mismos argumentos) salgan
// al servidor en paralelo mientras el primero sigue en curso (ej. varios
// componentes montándose a la vez, o clics repetidos antes de que responda
// la primera petición).
//
// No introduce caché: en cuanto la petición en curso termina (éxito o error),
// la siguiente llamada vuelve a pedir datos frescos al servidor. Pensado solo
// para queries de lectura (GET) con argumentos serializables — no usar con
// mutaciones ni con argumentos tipo FormData (no se pueden deduplicar de
// forma segura y la función deja pasar la petición sin bloquear).
const inFlightRequests = new Set()

const buildKey = (typeName, arg) => {
    try {
        return `${typeName}:${JSON.stringify(arg ?? null)}`
    } catch {
        return null
    }
}

export const createDedupedThunk = (typeName, payloadCreator) => {
    return createAsyncThunk(typeName, async (arg, thunkAPI) => {
        const key = buildKey(typeName, arg)
        try {
            return await payloadCreator(arg, thunkAPI)
        } finally {
            if (key) inFlightRequests.delete(key)
        }
    }, {
        condition: (arg) => {
            const key = buildKey(typeName, arg)
            if (!key) return true
            if (inFlightRequests.has(key)) return false
            inFlightRequests.add(key)
            return true
        }
    })
}
